import { render } from "./SpectrumCustomizerOverlay.vue?vue&type=template&id=1a5ff638"
import script from "./SpectrumCustomizerOverlay.vue?vue&type=script&lang=js"
export * from "./SpectrumCustomizerOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__